import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const BlockedNumberModalStyleParts = [
  'footer',
  'body',
  'inputContainer',
] as const

const helpers = createMultiStyleConfigHelpers(BlockedNumberModalStyleParts)

export const BlockedNumberModalStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    inputContainer: {
      width: '24rem',
      mb: '1rem',
      alignItems: 'center',
    },
    body: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1rem',
    },
    footer: {
      gap: '0.8rem',
      alignItems: 'flex-end',
    },
  },
})

export const useBlockedNumberModalStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof BlockedNumberModalStyleParts>(
    getName({ BlockedNumberModalStyles }),
    props,
  )
}
